module.exports = __webpack_public_path__ + "static/media/f_faceshape_square.b0ec4097.png";